import { render } from "./FormView.vue?vue&type=template&id=80fa6e86&scoped=true"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"

import "@/assets/css/views/FormView.scss?vue&type=style&index=0&id=80fa6e86&lang=scss&scoped=true"
import "@/assets/css/components/Ocr.scss?vue&type=style&index=1&id=80fa6e86&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fa6e86"]])

export default __exports__